// Documento/página principal
const $root = $(':root');

// Arquivo de configuração do tema
let confTheme = {};

// Verifica se está no modo de pré-visualização
const previewMode = $root.data('preview') == '1';

let sectionHomeCur;

// Verifica se está no modo de pré-visualização
if (previewMode) {
  // Evento geral disparado ao carregar as configurações
  const confEvtDefault = 'loaded-confs';

  // Recebe uma mensagem com a configuração do tema
  function receiveConfs(evt) {
    //console.log(evt);
    // Domínios confiáveis (Domínio do editor)
    const trustedSenders = ['http://localhost', 'https://lpqv.com.br', 'https://app.lpqv.com.br', 'https://lpqv.io'];
    // Verifica o remetente
    if (trustedSenders.indexOf(evt.origin) !== -1) {
      if (typeof evt.data === 'string') {
        const receivedConfs = JSON.parse(evt.data);
        const evtTriggered = receivedConfs.evt ? receivedConfs.evt : confEvtDefault;
        console.log(evtTriggered);
        if (evtTriggered) {
          // Seções dinâmicas home loja
          if (
            receivedConfs.section != '' &&
            (evtTriggered === 'shstore-add' || evtTriggered === 'shstore-upd' || evtTriggered === 'shstore-rem')
          ) {
            confTheme = JSON.parse(receivedConfs.settings);
            sectionHomeCur = receivedConfs.section;
            $root.trigger(evtTriggered);
          }
          // Preview popup
          else if (evtTriggered === 'popup-preview') {
            if ($('#popup-preview').length) {
              $('#popup-preview').data('preview', receivedConfs.settings);
              $('#popup-preview').trigger('draw-popup');
            }
          }
          // Foca em uma seção
          else if (evtTriggered === 'sec-focus') {
            lpLpsSecFocus(receivedConfs.section);
          }
          // Eventos de alterações gerais
          else {
            confTheme = JSON.parse(receivedConfs.settings);
            $root.trigger(evtTriggered);
          }
        }
      }
    }
    // Remetente não autorizado.
    /* else {
      console.log('Origin: ' + evt.origin);
      throw new Error('Você não possui permissão para executar esta operação.');
    } */
  }
  if (window.addEventListener) {
    window.addEventListener('message', receiveConfs, false);
  } else {
    window.attachEvent('onmessage', receiveConfs);
  }

  // Carrega as configurações armazenadas localmente
  /* $(window).on('load', function () {
    if (localStorage.getItem('conf_theme_' + baseTheme + '_' + baseTemplate + '_' + baseLanding)) {
      loadLocalConfs();
      $root.trigger(confEvtDefault);
    }
  }); */
  /* function loadLocalConfs() {
    const confThemeStore = localStorage.getItem('conf_theme_' + baseTheme + '_' + baseTemplate + '_' + baseLanding);
    if (confThemeStore) {
      confTheme = JSON.parse(confThemeStore);
    }
  } */

  // Desabilita os links e botões da página
  function disableLinks() {
    $('body').on('click', 'a, button', function (evt) {
      evt.preventDefault();
    });
  }
  disableLinks();

  // Desabilida o clique do botão direito do mouse
  function disableRightClick() {
    $(window).on('contextmenu', function (ev) {
      ev.preventDefault();
    });
  }
  disableRightClick();

  // Foca em uma seção
  function lpLpsSecFocus(section) {
    const $section = $(section);
    if ($section.length > 0) {
      let offset = 0;
      if ($('#header').length > 0 && $('#header').css('position') === 'fixed') {
        offset += $('#header').outerHeight();
      }
      if ($('#menu').length > 0 && $('#menu').css('position') === 'fixed') {
        offset += $('#menu').outerHeight();
      }
      smoothScroll($section, offset);
    }
  }

  // Configurações do MarkedJS
  if (typeof marked !== 'undefined') {
    marked.setOptions({
      breaks: true,
    });
  }

  // Altera a ordem das seções
  function changeSectionsOrder() {
    const orders = confTheme['sections-order'];
    if (orders && Object.keys(orders).length > 0) {
      Object.keys(orders).forEach((section) => {
        const $section = $('#' + section);
        const order = parseInt(confTheme['sections-order'][section]);
        if ($section.length > 0) {
          $section[0].style.setProperty('--order', order);
        }
      });
    }
  }
  $root.on(confEvtDefault + ' lp-evt-sections-order', changeSectionsOrder);
}

// Recarrega os carrosséis ao redimencionar a tela
$(window).on(
  'resize',
  debounce(function () {
    $('.carousel').each(function () {
      const $slider = $(this);
      if ($slider[0].slick !== undefined) {
        setTimeout(() => {
          $slider.slick('resize');
        }, 100);
        setTimeout(() => {
          $slider.slick('resize');
        }, 500);
      }
    });
  }, 100),
);

// Emitter
(function () {
  'use strict';
  //if (previewMode && (editorType === 'store' || editorType === 'landing')) {
  if (previewMode && !getUrlParam('template')) {
    let defaultEmitters;
    let sectionsEmitters;
    // Loja
    if (editorType === 'store') {
      // Seletores padrão
      defaultEmitters = [
        {
          selector: '.header-bar',
          'editor-page': '#lp-opt-top-bar',
          title: 'Barra superior',
          icon: 'image',
        },
        {
          selector: '.header-wrapper',
          'editor-page': '#lp-opt-header',
          title: 'Cabeçalho',
          icon: 'image',
        },
        {
          selector: '#menu',
          'editor-page': '#lp-opt-menu',
          title: 'Menu',
          icon: 'image',
        },
        {
          selector: '#header-menu',
          'editor-page': '#lp-opt-menu',
          title: 'Menu',
          icon: 'image',
        },
        {
          selector: '.footer-wrp',
          'editor-page': '#lp-opt-footer',
          title: 'Rodapé',
          icon: 'image',
        },
        {
          selector: '#newsletter',
          'editor-page': '#lp-opt-newsletter',
          title: 'Newsletter',
          icon: 'image',
        },
        {
          selector: '.footer-bar',
          'editor-page': '#lp-opt-footer-bar',
          title: 'Barra inferior',
          icon: 'image',
        },
        {
          selector: '.cart-side',
          'editor-page': '#lp-opt-cart',
          title: 'Carrinho lateral',
          icon: 'image',
        },
        /* {
          selector: '.carousel-prods',
          'editor-page': '#lp-opt-produtos',
          title: 'Caixa de produtos',
          icon: 'image',
        },
        {
          selector: '.catalogo-lista',
          'editor-page': '#lp-opt-produtos',
          title: 'Caixa de produtos',
          icon: 'image',
        }, */
        {
          selector: '.footer-redes',
          'editor-page': '#lp-opt-footer-redes-sociais',
          title: 'Redes sociais',
          icon: 'image',
        },
        {
          selector: '.footer-selos-col',
          'editor-page': '#lp-opt-footer-selos',
          title: 'Selos',
          icon: 'image',
        },
        {
          selector: '.footer-atendimento',
          'editor-page': '#lp-opt-footer-atendimento',
          title: 'Atendimento',
          icon: 'image',
        },
        {
          selector: '.catalogo-lista',
          'editor-page': '#lp-opt-produtos',
          title: 'Caixa de produtos',
          icon: 'image',
        },
        {
          selector: '.catalogo-lista',
          'editor-page': '#lp-opt-produtos',
          title: 'Caixa de produtos',
          icon: 'image',
        },
        {
          selector: '.header-banner',
          'editor-page': '#lp-opt-top-banner',
          title: 'Banner superior',
          icon: 'image',
        },
        {
          selector: '.header-logo',
          'editor-page': '#lp-opt-logo',
          title: 'Logotipo',
          icon: 'image',
        },
        {
          selector: '.header-search-wrp',
          'editor-page': '#lp-opt-busca',
          title: 'Busca',
          icon: 'image',
        },
        /* {
    selector: '.header-cart-btn-wrp',
    'editor-page': '#lp-opt-header-cart',
    title: 'Carrinho',
    icon: 'image',
  }, */
        {
          selector: '.footer-sobre',
          'editor-page': '#lp-opt-footer-sobre',
          title: 'Sobre',
          icon: 'image',
        },
        {
          selector: '.footer-pags',
          'editor-page': '#lp-opt-footer-paginas',
          title: 'Páginas',
          icon: 'image',
        },
        {
          selector: '.footer-cats',
          'editor-page': '#lp-opt-footer-categorias',
          title: 'Categorias',
          icon: 'image',
        },
        {
          selector: '.footer-pagamentos',
          'editor-page': '#lp-opt-footer-pay-forms',
          title: 'Formas de pagamento',
          icon: 'image',
        },
      ];
      // Informações seletores seções da home
      sectionsEmitters = {
        slide: {
          title: 'Slide',
          icon: 'image',
        },
        banners: {
          title: 'Banners',
          icon: 'image',
        },
        blog: {
          title: 'Blog',
          icon: 'image',
        },
        catalogo: {
          title: 'Coleção',
          icon: 'image',
        },
        catalogo_grid: {
          title: 'Coleção',
          icon: 'image',
        },
        catalogo_promo: {
          title: 'Coleção',
          icon: 'image',
        },
        categorias: {
          title: 'Categorias',
          icon: 'image',
        },
        depoimentos: {
          title: 'Depoimentos',
          icon: 'image',
        },
        destaques: {
          title: 'Ícones destaques',
          icon: 'image',
        },
        marcas: {
          title: 'Marcas',
          icon: 'image',
        },
        sobre: {
          title: 'Sobre',
          icon: 'image',
        },
      };
    }
    // Landing Page
    if (editorType === 'landing') {
      // Seletores padrão
      defaultEmitters = [
        {
          selector: '#header-wrapper',
          'editor-page': '#lp-opt-header',
          title: 'Cabeçalho',
          icon: 'image',
        },
        {
          selector: '#apresentacao .section-content',
          'editor-page': '#lp-opt-apresentacao',
          title: 'Apresentação',
          icon: 'image',
        },
        {
          selector: '#blocos',
          'editor-page': '#lp-opt-blocos',
          title: 'Destaques',
          icon: 'image',
        },
        {
          selector: '#caracteristicas',
          'editor-page': '#lp-opt-caracteristicas',
          title: 'Características',
          icon: 'image',
        },
        {
          selector: '#depoimentos',
          'editor-page': '#lp-opt-depoimentos',
          title: 'Depoimentos',
          icon: 'image',
        },
        {
          selector: '#produto',
          'editor-page': '#lp-opt-produto',
          title: 'Produto',
          icon: 'image',
        },
        {
          selector: '#produto-kits',
          'editor-page': '#lp-opt-produto-kits',
          title: 'Kits',
          icon: 'image',
        },
        {
          selector: '#catalogo',
          'editor-page': '#lp-opt-catalogo',
          title: 'Catálogo',
          icon: 'image',
        },
        {
          selector: '#garantia',
          'editor-page': '#lp-opt-garantia',
          title: 'Garantia',
          icon: 'image',
        },
        {
          selector: '#faq',
          'editor-page': '#lp-opt-faq',
          title: 'FAQ',
          icon: 'image',
        },
        {
          selector: '#slide',
          'editor-page': '#lp-opt-slide',
          title: 'Slide',
          icon: 'image',
        },
        {
          selector: '#banners',
          'editor-page': '#lp-opt-banners',
          title: 'Banners',
          icon: 'image',
        },
        {
          selector: '#footer',
          'editor-page': '#lp-opt-footer',
          title: 'Rodapé',
          icon: 'image',
        },
        {
          selector: '#vsl',
          'editor-page': '#lp-opt-vsl',
          title: 'Rodapé',
          icon: 'image',
        },
        {
          selector: '#bonus',
          'editor-page': '#lp-opt-bonus',
          title: 'Bônus',
          icon: 'image',
        },
        {
          selector: '#blocos-intercalados',
          'editor-page': '#lp-opt-blocos-intercalados',
          title: 'Blocos intercalados',
          icon: 'image',
        },
        {
          selector: '#fbc',
          'editor-page': '#lp-opt-fbc',
          title: 'Comentários',
          icon: 'image',
        },
        {
          selector: '#lp-opt-venda',
          'editor-page': '#lp-opt-lp-opt-venda',
          title: 'Venda',
          icon: 'image',
        },
      ];
    }
    // Checkout
    if (editorType === 'checkout') {
      // Seletores padrão
      defaultEmitters = [
        {
          selector: '#header',
          'editor-page': '#lp-opt-header',
          title: 'Cabeçalho',
          icon: 'image',
        },
        {
          selector: '#countdown',
          'editor-page': '#lp-opt-top-bar',
          title: 'Barra superior',
          icon: 'image',
        },
        {
          selector: '.co-banner',
          'editor-page': '#lp-opt-banner',
          title: 'Banner superior',
          icon: 'image',
        },
        {
          selector: '.co-infos',
          'editor-page': '#lp-opt-infos',
          title: 'Informações',
          icon: 'image',
        },
        {
          selector: '.co-address',
          'editor-page': '#lp-opt-address',
          title: 'Entrega',
          icon: 'image',
        },
        {
          selector: '.co-payment',
          'editor-page': '#lp-opt-payment',
          title: 'Pagamento',
          icon: 'image',
        },
        {
          selector: '.co-resume',
          'editor-page': '#lp-opt-resumo',
          title: 'Resumo',
          icon: 'image',
        },
        {
          selector: '.co-orderbump',
          'editor-page': '#lp-opt-order-bump',
          title: 'Order bump',
          icon: 'image',
        },
        {
          selector: '.co-social-proofs',
          'editor-page': '#lp-opt-depoimentos',
          title: 'Provas sociais',
          icon: 'image',
        },
        {
          selector: '#footer',
          'editor-page': '#lp-opt-footer',
          title: 'Rodapé',
          icon: 'image',
        },
      ];
    }

    // Atualiza os elementos editáveis
    function updateEmitters() {
      const emitters = defaultEmitters;
      if (editorType === 'store') {
        $('#sections-home .home-section').each(function () {
          const $section = $(this);
          emitters.push({
            selector: '#' + $section.attr('id'),
            title: sectionsEmitters[$section.data('sec-type')].title,
            icon: sectionsEmitters[$section.data('sec-type')].icon,
          });
        });
      }
      emitters.forEach(function (emitter) {
        const $emitter = $(emitter.selector);
        if ($emitter.length && !$emitter.hasClass('emitter')) {
          if ($emitter.css('position') === 'static') {
            $emitter.css('position', 'relative');
          }
          $emitter.addClass('emitter');
          $emitter.data('editor-page', emitter['editor-page']);
          $emitter.append(`<div class="emitter-info">${emitter.title}</div>`);
        }
      });
    }
    updateEmitters();
    $root.on('update-emitters', updateEmitters);

    // Ao clicar em uma seção para editar
    $('body').on('click', '.emitter', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      $('.emitter').removeClass('active');
      const $emitter = $(this);
      $emitter.addClass('active');
      if (editorType === 'store' && $emitter.hasClass('home-section')) {
        sendEmitter({
          evt: 'emitter',
          'editor-page': '#lp-opt-' + $emitter.data('sec-type'),
          'is-sec-home': true,
          'sec-home-type': $emitter.data('sec-type'),
          'sec-home-id': $emitter.attr('id'),
        });
      } else {
        sendEmitter({
          evt: 'emitter',
          'editor-page': $emitter.data('editor-page'),
          'is-sec-home': false,
          'sec-home-type': '',
          'sec-home-id': '',
        });
      }
    });

    // Envia a configuração para a página da loja
    function sendEmitter(emitterObj) {
      emitterObj = JSON.stringify(emitterObj);
      window.parent.postMessage(emitterObj, '*');
    }
  }
})();
